import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CreateAccount from './CreateAccount';
import ListAccounts from './ListAccounts';

const Accounts = (props) => {
  return (
    <Switch>
      <Route exact path="/o/accounts" component={ListAccounts} />
      <Route path="/o/accounts/new" component={CreateAccount} />
    </Switch>
  );
};

export default Accounts;
